import {
  SYNC_START,
  SYNC_REQUEST_START,
  SYNC_REQUEST_DONE,
  SYNC_DONE,
  SYNC_FAIL,
} from 'Reducers/Sync/const'

const defaultState = {
  syncing: false,
  syncingRequestIds: [],
  syncingRequests: {},
}

export const sync = (state = defaultState, action) => {
  // We may not hit this event if the sync has already started
  if (action.type === SYNC_START) {
    var syncingRequests = {}
    action.payload.requests.map(r => (syncingRequests[r.id] = r))

    return {
      ...state,
      syncing: true,
      error: null,
      syncingRequestIds: action.payload.requests.map(r => r.id),
      syncingRequests,
    }
  }

  if (action.type === SYNC_DONE) {
    return {
      ...state,
      syncing: false,
    }
  }

  if (action.type === SYNC_FAIL) {
    return {
      ...state,
      syncing: false,
      error: action.payload.error,
    }
  }

  if (action.type === SYNC_REQUEST_START) {
    // If the request we are syncing hasn't yet been added to the list of ids
    // then add it, this can happen if we load the page half way through a sync
    const syncingRequestIds = state.syncingRequestIds
      ? state.syncingRequestIds.slice(0)
      : []

    if (syncingRequestIds.indexOf(action.payload.requestId) == -1)
      syncingRequestIds.push(action.payload.requestId)

    return {
      ...state,
      syncing: true,
      syncingRequestIds,
      syncingRequests: {
        ...state.syncingRequests,
        [action.payload.requestId]: {
          syncing: true,
          method: action.payload.method,
          url: action.payload.url,
        },
      },
    }
  }

  if (action.type === SYNC_REQUEST_DONE) {
    return {
      ...state,
      syncingRequests: {
        ...state.syncingRequests,
        [action.payload.requestId]: {
          ...state.syncingRequests[action.payload.requestId],
          syncing: false,
          responseBody: action.payload.responseBody,
          statusCode: action.payload.statusCode,
        },
      },
    }
  }

  return state
}



// WEBPACK FOOTER //
// ./src/Reducers/Sync/reducer.js